import { render, staticRenderFns } from "./vector-group.component.vue?vue&type=template&id=27dec8b9&scoped=true&"
import script from "./vector-group.component.vue?vue&type=script&lang=js&"
export * from "./vector-group.component.vue?vue&type=script&lang=js&"
import style0 from "./vector-group.component.vue?vue&type=style&index=0&id=27dec8b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dec8b9",
  null
  
)

export default component.exports